ACC.pdppricelazyload = {
  $pdpPriceMain: '',
  $stockInfo: '',
  $instockInfo: '',
  $outstockInfo: '',
  isOneStoreClass: '.ph-isOneStore',
  $productApproval: $('.ph-productApproval').html(),
  disableEnterkeyClass: 'disable_enterkey',
  $salesOrgObj: $('.ph-pdpproduct-salesOrg').val(),
  disabledbuttonClass: 'ph-disabledbutton',
  pdpproductCode: '.ph-pdpproduct-code',
  isConfigClass: '.ph-isConfigurableProductPDP',

  bindAll: function() {
    var isHhs = $(document).find('.ph-isHHS').text(),
        currentCtn = $.trim(ACC.pdppricelazyload.$pdpPriceMain.find(ACC.pdppricelazyload.pdpproductCode).val()),
        isSpProduct = $.trim(ACC.pdppricelazyload.$pdpPriceMain.find('.ph-product-isSpProduct').val()),
        salesOrg = ACC.pdppricelazyload.$salesOrgObj,
        pageName = $('.ph-pagetype').html(),
        showPrice = $('.ph-showprice').val(),
        url = '',
        dataObj = {},
        contentType = 'application/x-www-form-urlencoded',
        isOneStore = $(ACC.pdppricelazyload.isOneStoreClass).html();


    if (isHhs === 'true' || isOneStore === 'true') {
      url = ACC.config.contextPath.concat('/lazyload/gethhspricedata');

      dataObj = {
        codes: currentCtn.toString()
      };

      if (isOneStore === 'true') {
        url = ACC.config.contextPath.concat('/lazyload/getPriceList');
        contentType = 'application/json';
        dataObj = {
          pageName: pageName,
          productList: [
            {
              code: currentCtn.toString()
            }
          ]
        };

        if (salesOrg) {
          dataObj.productList[0].salesOrg = salesOrg;
        }

        dataObj = JSON.stringify(dataObj);
      }

      if (String(showPrice) === 'true' && currentCtn !== '' && !ACC.pdppricelazyload.configValuesForReplaceCode(ACC.pdppricelazyload.$productApproval)) {
        ACC.pdppricelazyload.lazyloadPriceData(url, dataObj, isHhs, contentType);
      }
    } else {
      url = ACC.config.contextPath.concat('/lazyload/getpricedata');
      dataObj = {
        code: currentCtn,
        isSparePart: isSpProduct
      };

      if (currentCtn !== '') {
        ACC.pdppricelazyload.lazyloadPriceData(url, dataObj, isHhs, contentType);
      }
    }
  },
  configValuesForReplaceCode: function(productStatus) {
    var congigvalues = $('.productApprovalStatusConfig').html();
    var strArr = congigvalues.split(',');


    return strArr.includes(productStatus);
  },
  lazyloadPriceData: function(urlText, dataObj, isHhs, contentType) {
    var isOneStore = $(ACC.pdppricelazyload.isOneStoreClass).html(),
        isSparePart = $.trim(ACC.pdppricelazyload.$pdpPriceMain.find('.ph-product-isSpProduct').val()),
        checkAtpEnabled = $('.ph-checkATPEnabled').html(),
        atpCallChecks = isOneStore === 'true' && checkAtpEnabled === 'true' && ACC.pdppricelazyload.$productApproval === 'approved';

    $.ajax({
      type: 'POST',
      url: urlText,
      contentType: contentType,
      dataType: 'json',
      data: dataObj,
      success: function(result) {
        if (result) {
          $('.ph-pdp-loader').addClass('hidden');

          if (isHhs === 'true' || isOneStore === 'true') {
            result.forEach(function(productData) {
              if (isOneStore === 'true') {
                ACC.pdppricelazyload.inStockAndQuantity(productData, isSparePart);
                ACC.pdppricelazyload.substitutionMessage($('.ph-substitution'), productData);
              } else {
                ACC.pdppricelazyload.inStockAndQuantity(productData);
                ACC.pdppricelazyload.inStockAndQuantityHss(productData);
              }
            });
          } else {
            ACC.pdppricelazyload.inStockAndQuantity(result, isSparePart);
          }

          if (atpCallChecks === true && result[0] && result[0].price !== null) {
            ACC.pdppricelazyload.oneStoreAtpData();
          }
        }
      },
      error: function() {
        if (atpCallChecks === true) {
          ACC.pdppricelazyload.oneStoreAtpData();
        }
      }
    });
  },
  inStockAndQuantityHss: function(productData) {
    var deliveryDateValue = '',
        instockDeliveryRange = String($('.ph-hhsvar-instockDeliveryRange').text()),
        outofstockMessage = $('.ph-outofstock-message').text();

    if (String(productData.philipsATPData) !== 'null' && String(productData.philipsATPData.isProductInStock) === 'true' && productData.price !== null) {
      if (productData.philipsATPData.estimateDeliveryDate && productData.philipsATPData.estimateDeliveryDate !== '') {
        deliveryDateValue = instockDeliveryRange + '&nbsp;&nbsp;' + productData.philipsATPData.estimateDeliveryDate;
        $('.ph-pdp_stock_deliverytime').find('.ph-atpmessage').html(deliveryDateValue);
      }
    } else if (String(productData.philipsATPData) !== 'null') {
      if (String(productData.philipsATPData.isProductInStock) === 'false' || String(productData.philipsATPData.availableQuantity) === '0.0') {
        $('.ph-pdp_stock_deliverytime').find('.ph-atpmessage').html('<p class="strong ph-atpmessage">' + outofstockMessage + '</p>');
      }
    }
  },
  disbaleConfigurableForRseUser: function() {
    if ($(document).find('.isRseUser').text() === 'true') {
      $(ACC.pdppricelazyload.isConfigClass).val('false');
    }
  },
  inStockAndQuantity: function(result, isSparePart) {
    ACC.pdppricelazyload.metaFunctioncall(result);

    var priceHeading = $(document).find('.ph-pdp_yourprice_heading'),
        isConfigurableProduct = $(ACC.pdppricelazyload.isConfigClass).val(),
        islumifycheck = $.trim($(document).find('.ph-islumifycheck').text()),
        isOneStore = $(ACC.pdppricelazyload.isOneStoreClass).html();

    if (isSparePart === 'true' || isConfigurableProduct === 'true') {
      ACC.pdppricelazyload.loadPrice(result);
      priceHeading.removeClass('hidden');

      if (isConfigurableProduct === 'true') {
        priceHeading.text(priceHeading.attr('data-config'));
        ACC.pdppricelazyload.noPriceCheckButtons(result, isConfigurableProduct, islumifycheck);
      }

      if (isSparePart === 'true') {
        ACC.pdppricelazyload.normalButtons(result, islumifycheck);
        ACC.pdppricelazyload.sparepartInstockCheck(result, priceHeading);

        if (result.spProductAdditionalInfo && isOneStore !== 'true') {
          ACC.pdppricelazyload.additionalDetails(result);
        }

        ACC.pdppricelazyload.checkForSparePartProduct(result.code);
      }
    } else {
      if (result.price === null) {
        priceHeading.addClass('hidden');
      } else {
        ACC.pdppricelazyload.loadPrice(result);
        priceHeading.removeClass('hidden');
      }

      ACC.pdppricelazyload.normalButtons(result, islumifycheck);
    }
  },
  metaFunctioncall: function(result) {
    ACC.pdppricelazyload.disbaleConfigurableForRseUser();
    ACC.pdppricelazyload.buildMetaTag(result);
    ACC.pdppricelazyload.pdpAnalytics(result);
  },
  sparepartInstockCheck: function(result, priceHeading) {
    var stockStatus = '';

    stockStatus = ACC.pdppricelazyload.fetchStockStatus(result);

    if (result.price !== null && stockStatus === 'inStock') {
      ACC.pdppricelazyload.$stockInfo.addClass('hidden');
      ACC.pdppricelazyload.$instockInfo.removeClass('hidden');
      ACC.pdppricelazyload.$outstockInfo.addClass('hidden');
    } else if (result.price !== null && stockStatus === 'outOfStock') {
      ACC.pdppricelazyload.$stockInfo.addClass('hidden');
      ACC.pdppricelazyload.$instockInfo.addClass('hidden');
      ACC.pdppricelazyload.$outstockInfo.removeClass('hidden');
    } else {
      priceHeading.addClass('hidden');
      ACC.pdppricelazyload.$stockInfo.removeClass('hidden');
      ACC.pdppricelazyload.$instockInfo.addClass('hidden');
      ACC.pdppricelazyload.$outstockInfo.addClass('hidden');
    }
  },
  buildMetaTag: function(data) {
    var stockStatus = '',
        tagTemplate = '';

    if (data.stock && data.stock.stockLevelStatus && data.stock.stockLevelStatus.code) {
      stockStatus = data.stock.stockLevelStatus.code.toLowerCase();
      tagTemplate = tagTemplate + '<meta name="PHILIPS.METRICS.INSTOCK" content="' + stockStatus + '"></meta>\n';
    }

    if (data.price && data.price.finalPrice && data.price.currencyIso) {
      tagTemplate = tagTemplate + '<meta name="PHILIPS.METRICS.PRICE" content="' + data.price.finalPrice + '|' + data.price.currencyIso + '"></meta>\n';
    } else if (data.price && data.price.value && data.price.currencyIso) {
      tagTemplate = tagTemplate + '<meta name="PHILIPS.METRICS.PRICE" content="' + data.price.value + '|' + data.price.currencyIso + '"></meta>\n\n';
    }

    $('head>title').after(tagTemplate);
  },
  pdpAnalytics: function(data) {
    var productPrice = 0,
        prodcodeClass = 'ph-pdpproduct-code',
        productCode = $.trim(ACC.pdppricelazyload.$pdpPriceMain.find('.' + prodcodeClass).val());

    if (data.price && data.price.finalPrice) {
      productPrice = data.price.finalPrice;
    } else if (data.price && data.price.value) {
      productPrice = data.price.value;
    }

    if (window.prodDetail && window.prodDetail[productCode]) {
      var eddlAction = window.prodDetail[productCode];

      if (productPrice > 0) {
        eddlAction.ecommerce.detail.products[0].price = productPrice;
      }

      window.eddlEvents.push(eddlAction);
      window.prodDetail = {};
    }
  },
  fetchStockStatus: function(result) {
    var stockStatus = '';

    if (result.stock && result.stock.stockLevelStatus && result.stock.stockLevelStatus.code) {
      stockStatus = result.stock.stockLevelStatus.code;
    }

    return stockStatus;
  },
  priceNullCheck: function(value) {
    return value !== null && value !== '' && typeof value !== 'undefined';
  },
  noPriceforConfiguration: function() {
    var $yourPriceHeading = $('.ph-pdp_yourprice_heading');

    $yourPriceHeading.html($yourPriceHeading.attr('data-config'));
    $('.ph-pdp_pricestyle, .ph-pdp_promotion__section, .ph-pdp_stock_deliverytime').addClass(ACC.orderHistory.hidden);
    ACC.pdppricelazyload.$stockInfo.removeClass(ACC.orderHistory.hidden);
  },
  loadPrice: function(philipsProductData) {
    var priceData = philipsProductData.price,
        priceFree = $('.ph-free-text').text(),
        priceContainer = $('.ph-productpricecontainer').find('.ph-pdp_strike_price'),
        finalpriceContainer = $('.ph-productpricecontainer').find('.ph-pdp_strike_finalprice'),
        $strikeThroughListPriceFlag = $('.ph-strikeThroughListPrice-flag').text(),
        isConfigurableProduct = $('.ph-isConfigurableProductPDP').val();

    priceContainer.removeClass(ACC.orderHistory.hidden);

    if (isConfigurableProduct === 'true') {
      ACC.pdppricelazyload.noPriceforConfiguration();
    } else if (priceData) {
      if ($strikeThroughListPriceFlag === 'true') {
        var priceNullCheck = ACC.pdppricelazyload.priceNullCheck;

        priceContainer.removeClass('hidden');

        if (priceNullCheck(priceData.formattedFinalValue) && priceNullCheck(priceData.formattedValue) && priceData.formattedValue === priceData.formattedFinalValue) {
          priceContainer.addClass('hidden');
        }
      } else {
        priceContainer.addClass('hidden');
      }

      ACC.recentlyviewedproducts.renderPrice(priceData, priceFree, priceContainer, finalpriceContainer);
    }
  },
  normalButtons: function(product, islumifycheck) {
    var stockStatus = '',
        $productQty = $('.ph-pdp_product_quantity'),
        atpMessage = 'ph-atpmessage',
        approvalRohOrObsolete = product.approval === 'regulatoryonhold' || product.approval === 'obsolete';

    $productQty.addClass(ACC.orderHistory.hidden);
    ACC.pdppricelazyload.$stockInfo.addClass(ACC.orderHistory.hidden);

    if (product.stock && product.stock.stockLevelStatus && product.stock.stockLevelStatus.code) {
      stockStatus = product.stock.stockLevelStatus.code;
    }

    if (stockStatus === 'outOfStock' || product.price === null || approvalRohOrObsolete) {
      ACC.pdppricelazyload.$stockInfo.removeClass('hidden');
      $('.' + atpMessage).addClass('hidden');
    }

    ACC.pdppricelazyload.renderButton(product, stockStatus, islumifycheck);
    ACC.pdppricelazyload.showhideQuantityBox(stockStatus, approvalRohOrObsolete, $productQty);

    if ($('.ph-lumifyTransducer').attr('data-istransducer') === 'true') {
      $('.ph-pdp_addtocart_button').addClass('ph-lumifyconfigurelink').attr('data-page', 'pdp');
      $('.ph-pdp_addtocart_button').attr('type', 'button').attr('data-productcode', $(ACC.pdppricelazyload.pdpproductCode).val());
    }

    if ($('.ph-pdp-isConfigitEnabled').text() === 'true') {
      ACC.pdppricelazyload.noPriceforConfiguration();
    }
  },
  showhideQuantityBox: function(stockStatus, approvalRohOrObsolete, $productQty) {
    if (stockStatus === 'inStock' && !approvalRohOrObsolete) {
      $productQty.removeClass('hidden');
      $('.ph-plp_product_leadtime').removeClass('hidden');
    }

    if ($('.ph-pdp_addtocart_button').hasClass(ACC.pdppricelazyload.disabledbuttonClass)) {
      $productQty.addClass('hidden');
    }
  },
  renderButton: function(philipsProductData, stockStatus, islumifycheck) {
    var allowAddToCart = $(document).find('.ph-pdp-allowAddToCart').text(),
        isConfigurableItem = 'false',
        basket = $(document).find('.ph-pdp-basket-icon'),
        buttonTemplateNew = '',
        buttonType = 'button',
        isRseUser = $(document).find('.isRseUser').text();


    if (allowAddToCart === 'true' && philipsProductData.price && philipsProductData.price.value && stockStatus === 'inStock') {
      buttonType = 'submit';
      isConfigurableItem = $(document).find('.ph-isConfigurableProductPDP.isConfigurableItem').val();
      ACC.pdp.igtdMessageDisplay(philipsProductData.code);
    }

    if (isRseUser === 'true') {
      buttonType = 'button';
    }

    buttonTemplateNew = ACC.pdppricelazyload.renderButtonsecond(philipsProductData, islumifycheck, isConfigurableItem, buttonType);

    basket.after(buttonTemplateNew);
    basket.closest('.ph-setico').removeClass('ph-setico');
  },
  renderButtonsecond: function(philipsProductData, islumifycheck, isConfigurableItem, buttonType) {
    var cartIcon = $(document).find('.ph-pdp-addtocart-icon').html(),
        basket = $(document).find('.ph-pdp-basket-icon'),
        basketIcon = basket.html(),
        buttonTemplate = '',
        addToCartLabelText = $('.accessibilityTransAddToCart').text(),
        isinnosightcheck = $.trim($(document).find('.ph-isinnosightcheck').text());

    if ($(document).find('.ph-pdpconfigitbutton').length > 0) {
      buttonTemplate = '<span class="hidden configit_enabled"></span>';
    } else if (isConfigurableItem === 'true' && philipsProductData.approval !== 'regulatoryonhold' && philipsProductData.approval !== 'obsolete' && islumifycheck !== 'true') {
      buttonTemplate = '<button type="button" data-page="pdp" data-isLumify="' + islumifycheck + '" data-isInnosight="' +
       isinnosightcheck + '" data-productcode="' + philipsProductData.code;
      buttonTemplate = buttonTemplate + 'class="ph-pdpconfigbutton ph-pl-0 ph-mr-md-2 ph-mr-lg-1 ph-orangebutton large ph-positive ph-pdp-button ph-float-left"' +
                    'aria-label="' + addToCartLabelText + '"><span class="ph-pdp_addtocart_icon"></span>' + cartIcon + basketIcon + '</button>';
    } else {
      buttonTemplate = '<button type="' + buttonType + '" data-page="pdp" data-isLumify="' + islumifycheck + '" data-productcode="' + philipsProductData.code;
      buttonTemplate = buttonTemplate + '" class="ph-pl-0 ph-mr-md-2  ph-mr-lg-1 ph-orangebutton ph-pdp_addtocart_button ';
      buttonTemplate = buttonTemplate + 'large ph-taggingPdp ph-pdp-button';

      if (buttonType === 'button' || philipsProductData.approval === 'regulatoryonhold' || philipsProductData.approval === 'obsolete') {
        buttonTemplate = buttonTemplate + ' out-of-stock ph-disabledbutton" disabled="true" aria-disabled="true" aria-label="' + addToCartLabelText + '">';
      } else {
        buttonTemplate = buttonTemplate + '" aria-label="' + addToCartLabelText + '">';
      }

      buttonTemplate = buttonTemplate + '<span class="ph-pdp_addtocart_icon"></span>' + cartIcon + basketIcon + '</button>';
    }

    return buttonTemplate;
  },
  noPriceCheckButtons: function(product, isConfigurableProduct, islumifycheck) {
    ACC.pdppricelazyload.renderNoPriceCheckButton(product, isConfigurableProduct, islumifycheck);

    var isOneStore = $(ACC.pdppricelazyload.isOneStoreClass).html();

    if (product.spProductAdditionalInfo && isOneStore !== 'true') {
      ACC.pdppricelazyload.additionalDetails(product);
    }
  },
  checkForSparePartProduct: function(itemCode) {
    var $addToFormObj = $('#addToCartForm');

    if ($addToFormObj.find('.ph-product-isSpProduct').val() === 'true') {
      $addToFormObj.find('button[data-productcode="' + itemCode + '"]').addClass('ph-sparepart_ack_pdp');
    }
  },
  renderNoPriceCheckButton: function(product, isConfigurableProduct, islumifycheck) {
    var cartIcon = $(document).find('.ph-pdp-addtocart-icon').html(),
        basket = $(document).find('.ph-pdp-basket-icon'),
        basketIcon = basket.html(),
        buttonTemplate = '',
        productButtonType = 'submit',
        aedButtonClass = '',
        isinnosightcheck = $.trim($(document).find('.ph-isinnosightcheck').text());

    if (isConfigurableProduct === 'true') {
      productButtonType = 'button';
      aedButtonClass = 'ph-pdpconfigbutton';
    }

    if ($(document).find('.ph-pdpconfigitbutton').length > 0) {
      buttonTemplate = '<span class="hidden configit_enabled"></span>';
    } else if (product.approval === 'regulatoryonhold' || product.approval === 'obsolete') {
      buttonTemplate = '<button type="' + productButtonType + '" data-page="pdp" data-productcode="' + product.code + '" data-isLumify="' +
      islumifycheck + '" data-isInnosight="' + isinnosightcheck;
      buttonTemplate = buttonTemplate + '" class="' + aedButtonClass + ' ph-pl-0 ph-mr-md-2 ph-mr-lg-1 ph-orangebutton ';
      buttonTemplate = buttonTemplate + 'large ph-positive ph-float-left';
      buttonTemplate = buttonTemplate + ' out-of-stock ph-disabledbutton" disabled="true" aria-disabled="true">';
      buttonTemplate = buttonTemplate + '<span class="ph-pdp_addtocart_icon"></span>' + cartIcon + basketIcon + '</button>';
    } else {
      buttonTemplate = '<button type="button" data-page="pdp" data-productcode="' + product.code + '" data-isLumify="' +
      islumifycheck + '" data-isInnosight="' + isinnosightcheck;
      buttonTemplate = buttonTemplate + '" class="ph-pdpconfigbutton ph-pl-0 ph-mr-md-2 ph-mr-lg-1 ph-orangebutton ';
      buttonTemplate = buttonTemplate + 'large ph-positive ph-float-left"><span class="ph-pdp_addtocart_icon"></span>' + cartIcon + basketIcon + '</button>';
      $('.ph-pdp_product_quantity').removeClass('hidden');
    }

    basket.after(buttonTemplate);
    ACC.pdppricelazyload.checkForSparePartProduct(product.code);
    basket.closest('.ph-setico').removeClass('ph-setico');
  },
  additionalDetails: function(data) {
    var additInfo = '',
        rowOpening = '<div class="ph-d-flex ph-flex-column ph-flex-sm-row ph-pb-2 ph-pb-sm-0"><div class="ph-productdetailpage__featuresubhead">';

    $.each(data.spProductAdditionalInfo, function(k, v) {
      var additInfoText = $('.ph-spareparts__additional_details_text').attr('data-' + k),
          additInfoValue = v;

      if (k === 'unitOfMeasure') {
        additInfoValue = data.unitOfMeasure;
      }

      if (additInfoValue) {
        additInfo = additInfo + rowOpening;
        additInfo = additInfo + additInfoText + '</div>';
        additInfo = additInfo + '<div class="productdetailpage__featuresubdetails">';

        if (k === 'loggr' && data.countrygroup) {
          additInfo = additInfo + $('.ph-spareparts__additional_details_replace_text').attr('data-' + data.countrygroup);
        } else if (k !== 'loggr') {
          additInfo = additInfo + additInfoValue;
        }

        additInfo = additInfo + '</div></div>';
      }
    });

    if (data.baseUnitOfMeasureCode) {
      additInfo = additInfo + rowOpening;
      additInfo = additInfo + $('.ph-spareparts__additional_details_text').attr('data-unitOfMeasure') + '</div>';
      additInfo = additInfo + data.baseUnitOfMeasureCode;
      additInfo = additInfo + '</div></div>';
    }

    if (additInfo !== '') {
      $('.ph-spareparts__additional_details_wrapper').removeClass('hidden');
      $('.ph-spareparts__additional_details').html(additInfo);
    }
  },
  hazardousCheck: function(onestorePhilipsAtpData) {
    var atpHazardousCode = $('.ph-atpHazardousCode').html();

    if (onestorePhilipsAtpData.isSpProduct !== true && onestorePhilipsAtpData.hazardousCode === atpHazardousCode) {
      return true;
    }

    return false;
  },
  atpDetailstag: function(onestorePhilipsAtpData) {
    var atpinStockhazardousmsg = $('.ph-atpinStockhazardousmsg').html(),
        atpOutofStock = $('.ph-atpOutofStock').html(),
        rdcdeliveryrange = $('.ph-rdcdeliveryrange').html(),
        instockDeliveryRange = $('.ph-instockDeliveryRange').html(),
        atpDetailsStr = ' ',
        errorMessage = $.trim($('.ph-errorMessage').html()),
        inStock = $('.ph-inStock').html(),
        outofStock = $('.ph-outofStock').html();

    atpDetailsStr = atpDetailsStr + '<p class="ph-atpmessage strong">';

    if (onestorePhilipsAtpData && onestorePhilipsAtpData.philipsATPData) {
      if (onestorePhilipsAtpData.philipsATPData.isError && errorMessage !== 'null') {
        atpDetailsStr = atpDetailsStr + errorMessage;
      } else if (onestorePhilipsAtpData.approval !== 'regulatoryonhold' && onestorePhilipsAtpData.approval !== 'obsolete') {
        if (ACC.pdppricelazyload.hazardousCheck(onestorePhilipsAtpData) && onestorePhilipsAtpData.philipsATPData.isProductInStock === true) {
          atpDetailsStr = atpDetailsStr + atpinStockhazardousmsg;
        } else if (onestorePhilipsAtpData.philipsATPData.isProductInStock === true) {
          atpDetailsStr = atpDetailsStr + ACC.pdppricelazyload.oneStoreAtpDatastr(onestorePhilipsAtpData, instockDeliveryRange, inStock);
        } else {
          atpDetailsStr = atpDetailsStr + ACC.pdppricelazyload.oneStoreAtpDatastrFalse(onestorePhilipsAtpData, atpOutofStock, rdcdeliveryrange, outofStock);
        }
      }

      atpDetailsStr = atpDetailsStr + '</p>';
    }

    $('.ph-oneStoreAtp').html(atpDetailsStr);
  },
  oneStoreAtpDatastr: function(onestorePhilipsAtpData, instockDeliveryRange, inStock) {
    var atpDetailsStrTrue = ' ',
        atpvarAtpleadTime = String($('.ph-atpvar-atpleadTime').html());

    if (onestorePhilipsAtpData.atpIdentifier === ('' || null)) {
      if (onestorePhilipsAtpData.philipsATPData.estimateDeliveryDate && onestorePhilipsAtpData.isSpProduct === true) {
        atpDetailsStrTrue = instockDeliveryRange + ' ' +
            onestorePhilipsAtpData.philipsATPData.estimateDeliveryDate;
      } else if (onestorePhilipsAtpData.leadTime && onestorePhilipsAtpData.leadTime > 0) {
        atpDetailsStrTrue = atpvarAtpleadTime.replace('{0}', onestorePhilipsAtpData.leadTime);
      } else if (onestorePhilipsAtpData.isSpProduct === true) {
        atpDetailsStrTrue = inStock;
      }
    } else if (onestorePhilipsAtpData.philipsATPData.estimateDeliveryDate) {
      atpDetailsStrTrue = instockDeliveryRange + ' ' +
          onestorePhilipsAtpData.philipsATPData.estimateDeliveryDate;
    }

    return atpDetailsStrTrue;
  },
  atpNoIdentifierCase: function(onestorePhilipsAtpData, outofStock) {
    var atpDetailsStrFalse = ' ',
        atpvarAtpleadTime = String($('.ph-atpvar-atpleadTime').html()),
        outofStockDeliveryRange = $('.ph-outofStockDeliveryRange').html();

    if (onestorePhilipsAtpData.leadTime && onestorePhilipsAtpData.leadTime > 0) {
      atpDetailsStrFalse = atpvarAtpleadTime.replace('{0}', onestorePhilipsAtpData.leadTime);
    } else if (onestorePhilipsAtpData.isSpProduct === true && onestorePhilipsAtpData.philipsATPData.outOfStockEstimateDeliveryDate) {
      atpDetailsStrFalse = outofStockDeliveryRange + ' ' + onestorePhilipsAtpData.philipsATPData.outOfStockEstimateDeliveryDate;
    } else if (onestorePhilipsAtpData.isSpProduct === true) {
      atpDetailsStrFalse = outofStock;
    }

    return atpDetailsStrFalse;
  },
  oneStoreAtpDatastrFalse: function(onestorePhilipsAtpData, atpOutofStock, rdcdeliveryrange, outofStock) {
    var atpDetailsStrFalse = ' ';

    if (onestorePhilipsAtpData.atpIdentifier === 'MP1' && onestorePhilipsAtpData.philipsATPData.outOfStockEstimateDeliveryDate) {
      atpDetailsStrFalse = rdcdeliveryrange + ' ' + onestorePhilipsAtpData.philipsATPData.outOfStockEstimateDeliveryDate;
    } else if (onestorePhilipsAtpData.atpIdentifier === 'MCP' || onestorePhilipsAtpData.atpIdentifier === 'PRD') {
      atpDetailsStrFalse = atpOutofStock;
    } else if (onestorePhilipsAtpData.atpIdentifier === ('' || null)) {
      atpDetailsStrFalse = ACC.pdppricelazyload.atpNoIdentifierCase(onestorePhilipsAtpData, outofStock);
    }

    return atpDetailsStrFalse;
  },
  additionalDetailsOneStore: function(onestorePhilipsAtpData) {
    var additInfo = '',
        rowOpening = '<div class="ph-d-flex ph-flex-column ph-flex-sm-row ph-pb-2 ph-pb-sm-0"><div class="ph-productdetailpage__featuresubhead">';

    $.each(onestorePhilipsAtpData, function(k, v) {
      var addList = [
        'hsCode',
        'weight',
        'countryOfOrigin',
        'logisticsHandlingGroup',
        'unitofMeasure'

      ];

      if (addList.indexOf(k) !== -1) {
        var additInfoText = '',
            additInfoValue = v;

        if (k === 'logisticsHandlingGroup') {
          additInfoText = $('.ph-spareparts__additional_details_text').attr('data-' + k + '-' + v);
        } else {
          additInfoText = $('.ph-spareparts__additional_details_text').attr('data-' + k);
        }

        if (additInfoValue) {
          additInfo = additInfo + rowOpening;
          additInfo = additInfo + additInfoText + '</div>';
          additInfo = additInfo + '<div class="productdetailpage__featuresubdetails">';

          if (k === 'logisticsHandlingGroup' && onestorePhilipsAtpData.countryGroup) {
            additInfo = additInfo + $('.ph-spareparts__additional_details_replace_text').attr('data-' + onestorePhilipsAtpData.countryGroup + '-' + v);
          } else if (k !== 'logisticsHandlingGroup') {
            additInfo = additInfo + additInfoValue;
          }

          additInfo = additInfo + '</div></div>';
        }
      }
    });
    ACC.pdppricelazyload.additionalDetailsOneStoreStruct(additInfo);
  },
  additionalDetailsOneStoreStruct: function(additInfo) {
    if (additInfo !== '') {
      $('.ph-spareparts__additional_details_wrapper').removeClass('hidden');
      $('.ph-spareparts__additional_details').html(additInfo);
    }
  },
  oneStoreAtpData: function() {
    var dataObj = {
      productList: [
        {
          code: $(ACC.pdppricelazyload.pdpproductCode).val(),
          salesOrg: ''
        }
      ]
    };

    if (ACC.pdppricelazyload.$salesOrgObj) {
      dataObj.productList[0].salesOrg = ACC.pdppricelazyload.$salesOrgObj;
    }

    $.ajax({
      type: 'POST',
      url: ACC.config.contextPath + '/lazyload/getATPDetails.json',
      contentType: 'application/json',
      dataType: 'json',
      data: JSON.stringify(dataObj),
      success: function(result) {
        if (result) {
          result.forEach(function(onestorePhilipsAtpData) {
            if (dataObj.productList[0].code === onestorePhilipsAtpData.code) {
              ACC.pdppricelazyload.atpDetailstag(onestorePhilipsAtpData);
              ACC.pdppricelazyload.additionalDetailsOneStore(onestorePhilipsAtpData);
            }
          });
        }
      }
    });
  },
  substitutionMessage: function($substitutionElement, priceCallResult) {
    if (priceCallResult.substitutionProduct && priceCallResult.substitutionProduct.productCode) {
      $substitutionElement.show();

      if (priceCallResult.substitutionProduct.productURL) {
        var substitutionMsgTxt = $substitutionElement.find('.ph-substitution_message').html(),
            substitutionUrlTxt = $substitutionElement.find('.ph-substitution_productlabel').html(),
            substProductCode = priceCallResult.substitutionProduct.productCode,
            substHtml = '<a href="' + priceCallResult.substitutionProduct.productURL + '">';

        substHtml = substHtml + '<span class="ph-substitution_message">' + substitutionMsgTxt + '&nbsp;</span>';
        substHtml = substHtml + '<span class="ph-substitution_productlabel">' + substitutionUrlTxt + ' ' + substProductCode + '</span>';
        substHtml = substHtml + '</a>';
        $substitutionElement.html(substHtml);
      }

      ACC.pdppricelazyload.hidePriceDisableAddtoCart($substitutionElement);
    }
  },
  hidePriceDisableAddtoCart: function($substitutionElement) {
    var pdpPageElem = $substitutionElement.parents('.ph-pdp_product_description_main'),
        plpCardItemElem = $substitutionElement.parents('.ph-decisionpage__card');

    if (pdpPageElem.length > 0) {
      $('.ph-pdp_pricesection').hide();
      $('.ph-pdp-stockinformation').hide();
      $('.ph-pdp-button.ph-pdp_addtocart_button').attr('type', 'button').attr('disabled', 'true').addClass(ACC.pdppricelazyload.disabledbuttonClass);
      $('.ph-prod-addtoshoppinglist').addClass('ph-disabledlink');
      $('.ph-pdp_qty').addClass('hidden');
      $('.ph-pdp_qty_plusminus').addClass('hidden');
    } else if (plpCardItemElem.length > 0) {
      plpCardItemElem.find('.ph-decision-page__price').hide();
      plpCardItemElem.find('.ph-product__outofstock').hide();
      plpCardItemElem.find('.ph-atpmsgdiv').hide();
      plpCardItemElem.find('.ph-addtocart').attr('type', 'button').attr('disabled', 'true').addClass(ACC.pdppricelazyload.disabledbuttonClass);
      plpCardItemElem.find('.ph-addshoppinglistbtn').addClass('ph-disabledlink');
      plpCardItemElem.find('.ph-quantity').addClass('hidden');
    }
  },

  recentlyViewedProducts: function() {
    var salesOrg = '',
        pdpproductCode = $.trim($(ACC.pdppricelazyload.pdpproductCode).val());

    if (ACC.pdppricelazyload.$salesOrgObj) {
      salesOrg = ACC.pdppricelazyload.$salesOrgObj;
    }

    if (pdpproductCode !== '') {
      $.ajax({
        type: 'POST',
        url: ACC.config.contextPath + '/lazyload/updateRecentlyViewedItem.json',
        data: {
          productcode: $(ACC.pdppricelazyload.pdpproductCode).val(),
          salesOrg: salesOrg
        },
        async: false,
        cache: true,
        headers: {
          'Cache-Control': ACC.pdp.maxAgeValue
        },
        dataType: 'json',
        success: function() {
          document.getElementById('recentProductUpdateStatus').innerHTML = 'product added';
        }
      });
    }
  }
};
$(document).ready(function() {
  if ($('.ph-pdp_product_description_main').length > 0) {
    ACC.pdppricelazyload.$pdpPriceMain = $('.ph-pdp_priceaddtocart_main');
    ACC.pdppricelazyload.$stockInfo = $('.ph-stock-info');
    ACC.pdppricelazyload.$instockInfo = $('.ph-instock-info');
    ACC.pdppricelazyload.$outstockInfo = $('.ph-outstock-info');

    ACC.pdppricelazyload.bindAll();

    if (ACC.pdppricelazyload.configValuesForReplaceCode(ACC.pdppricelazyload.$productApproval)) {
      $('.ph-replacecode-config').show();
      $('.ph-pdp_pricesection').hide();
      $('.ph-pdp-loader').addClass('hidden');
      $('.ph-pdp-button.ph-pdp_addtocart_button').attr('type', 'button').attr('disabled', 'true').addClass(ACC.pdppricelazyload.disabledbuttonClass);
      $('.ph-prod-addtoshoppinglist').addClass('hidden');
      $('.ph-pdp_qty').addClass('hidden');
      $('.ph-pdp_qty_plusminus').addClass('hidden');
    }

    ACC.pdppricelazyload.recentlyViewedProducts();
  }
});
